<mtg-button
  color="secondary"
  class="download-btn"
  leadingIcon="icons-cloud-download"
  [mtgDropdownTriggerFor]="files"
>
  Документы
</mtg-button>
<mtg-dropdown-menu #files>
  <mtg-dropdown-item (click)="downloadProtocol('pdf')">Протокол pdf</mtg-dropdown-item>
  <mtg-dropdown-item (click)="downloadStatistic('xlsx')">Статистика Excel</mtg-dropdown-item>
  <mtg-dropdown-item (click)="downloadStatistic('pdf')">Статистика pdf</mtg-dropdown-item>
</mtg-dropdown-menu>
